import { adminFetch } from "./base";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface DsarRequest {
  readonly id: string;
  readonly type: string;
  readonly status: string;
  readonly identifier_phone: string | null;
  readonly identifier_email: string | null;
  readonly details: string | null;
  readonly sla_deadline: string;
  readonly assigned_to: string | null;
  readonly created_at: string;
}

export interface DsarListResponse {
  readonly requests: readonly DsarRequest[];
  readonly pagination: {
    readonly page: number;
    readonly limit: number;
    readonly total: number;
  };
}

// ---------------------------------------------------------------------------
// API client
// ---------------------------------------------------------------------------

export interface CreateDsarRequest {
  readonly type: string;
  readonly identifier_phone?: string;
  readonly identifier_email?: string;
  readonly details?: string;
}

export interface UpdateDsarRequest {
  readonly status: string;
  readonly notes?: string;
}

export const privacyApi = {
  listRequests: (params: Record<string, string> = {}) => {
    const qs =
      Object.keys(params).length > 0
        ? `?${new URLSearchParams(params).toString()}`
        : "";
    return adminFetch<DsarListResponse>(`/api/admin/privacy/requests${qs}`);
  },

  executeRequest: (id: string, action: "approve" | "reject", reason?: string) =>
    adminFetch<{ readonly success: boolean }>(
      `/api/admin/privacy/requests/${encodeURIComponent(id)}`,
      {
        method: "POST",
        body: JSON.stringify({ action, rejection_reason: reason }),
      },
    ),

  createRequest: (data: CreateDsarRequest) =>
    adminFetch<{ readonly request: DsarRequest }>(
      "/api/admin/privacy/requests",
      { method: "POST", body: JSON.stringify(data) }
    ),

  updateRequest: (id: string, data: UpdateDsarRequest) =>
    adminFetch<{ readonly request: DsarRequest }>(
      `/api/admin/privacy/requests/${encodeURIComponent(id)}`,
      { method: "PATCH", body: JSON.stringify(data) }
    ),
} as const;
